export default __webpack_public_path__ + "static/media/pic2.6edea563.jpg";